import React, {
    PropTypes,
} from 'react';
import {OrdersHistory, HistoryTable, OldMenu} from './';
import {ChangeUser, CreateReport, DateDiapasonChange, ShowHistoryEntry, CloseEntry} from './actions';
import {connect} from 'react-redux';
import {Alert, Button} from 'react-bootstrap';

class OrderHistoryPage extends React.Component {
    static  propTypes = {
        ChangeUser: PropTypes.func.isRequired,
        CreateReport: PropTypes.func.isRequired,
        DateDiapasonChange: PropTypes.func.isRequired,
        ShowHistoryEntry: PropTypes.func.isRequired,
        CloseEntry: PropTypes.func.isRequired,
        old: PropTypes.array.isRequired,
        showOld: PropTypes.bool.isRequired,
        users: PropTypes.array.isRequired,
        user: PropTypes.object.isRequired,
        begin: PropTypes.object.isRequired,
        end: PropTypes.object.isRequired,
        total: PropTypes.number.isRequired,
        oldDate: PropTypes.string.isRequired,
    };

    render() {
        const {
            begin, end, DateDiapasonChange, CreateReport, ShowHistoryEntry, CloseEntry,
            ChangeUser, users, user, history, error, old, showOld, total, oldDate
        } = this.props;
        const historical = <div>
            <OrdersHistory
                {...{DateDiapasonChange, CreateReport, ChangeUser}}
                begin={begin}
                end={end}
                user={user}
                users={users}
            />

            {error ? <Alert className="mt15" bsStyle="danger"><p>{error}</p></Alert> : ''}
            {history.length ? <HistoryTable history={history} total={total} {...{ShowHistoryEntry, user}}/> : ''}
        </div>;
        const single = <div>
            <Button block bsStyle="success" onClick={CloseEntry}>Вернуться назад</Button>
            <OldMenu saleTimes={old} date={oldDate}/>
        </div>;
        return (
            <div className="col-md-12 col-lg-8">
                {showOld ? single : historical}
            </div>
        );
    }
}

function mapStateToProps(state) {
    const history = state.history;
    return {
        ...history,
        users: state.food.objects
    }
}

export default connect(mapStateToProps,
    {ChangeUser, CreateReport, DateDiapasonChange, ShowHistoryEntry, CloseEntry}
)(OrderHistoryPage);



/** WEBPACK FOOTER **
 ** ./src/modules/food/OrderHistoryPage.js
 **/